import { render } from "./YesNo.vue?vue&type=template&id=1b0a7d6e&scoped=true"
import script from "./YesNo.vue?vue&type=script&lang=js"
export * from "./YesNo.vue?vue&type=script&lang=js"

import "./YesNo.vue?vue&type=style&index=0&id=1b0a7d6e&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0a7d6e"]])

export default __exports__